export default function PHP_zip_entry_filesize() {
  return (
    <div>
      <h1>PHP_zip_entry_filesize</h1>
    </div>
  );
}
